import {
  HeaderSelectors,
  LanguageSwitcherSelectors,
  UISelectors,
  UserContextSelectors
} from "../../redux/selectors";
import React, { useCallback, useMemo } from "react";

import PropTypes from "prop-types";
import { UrlUtils, MessageBrokerUtils } from "../../utils";
import { useCrossSellComunicationHandlers } from "../../hooks";
import { useCrossSellProps } from "./index";
import { useSelector } from "react-redux";
import { Channel, Topic } from "../../constants";
import { BrandUtils } from "../../utils/brandUtils";
import { SVGIcon2 } from "../../components/common/SVGIconV2";
import { useFeature } from "../../hooks/useFeature";
import { AppFeatures } from "../../constants/featureFlags";

const CrossActivity = ({ trackingInfo }) => {
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const isPC = useSelector(UserContextSelectors.isPC);
  const lang = useSelector(LanguageSwitcherSelectors.lang);
  const userCountry = useSelector(UserContextSelectors.userCountry);
  const bodyClassName = useSelector(HeaderSelectors.bodyClassName);
  const links = useSelector(UISelectors.links);
  const isCasinoCrossSellActive = useFeature(AppFeatures.CASINO_CROSS_SELL);
  const isPokerCrossSellActive = useFeature(AppFeatures.POKER_CROSS_SELL);
  const isPokerCrossSellTesting = useFeature(
    AppFeatures.POKER_CROSS_SELL_TESTING
  );

  const { openCasino } = useCrossSellComunicationHandlers();

  const getOnClickHandler = useCallback(() => {
    const onNavigationClick = url => {
      const openUrl = UrlUtils.getURLWithSCut(url, true);
      window.open(openUrl, "_blank");
    };

    const onClickCasino = event => {
      openCasino();

      event.preventDefault();
    };

    const onClickPoker = event => {
      if (BrandUtils.isPokerClient()) {
        return;
      }
      event.preventDefault();

      if (isAuthenticated && links.pokerUrlAuthenticated)
        onNavigationClick(links.pokerUrlAuthenticated);
      else onNavigationClick(links.pokerUrl);
    };

    const onClickSport = event => {
      if (BrandUtils.isPokerClient() !== true) {
        return;
      }

      event.preventDefault();

      if (isAuthenticated !== true) {
        window.open(links.sportUrl, "_blank");
        return;
      }

      MessageBrokerUtils.publish({
        channel: Channel.CROSS_SELL,
        topic: Topic.CTA_SportClient_Open,
        headers: { publisher: "UAA" }
      });
    };

    return {
      onClickCasino,
      onClickPoker,
      onClickSport
    };
  }, [isAuthenticated, links, openCasino]);

  const crossActivityProps = useMemo(
    () => ({
      onClickHandler: getOnClickHandler(),
      isCasinoCrossSellActive,
      isPokerCrossSellActive,
      isPokerCrossSellTesting,
      isAuthenticated,
      isPC,
      lang,
      userCountry,
      bodyClassName,
      trackingInfo
    }),
    [
      bodyClassName,
      isAuthenticated,
      isCasinoCrossSellActive,
      isPokerCrossSellActive,
      isPokerCrossSellTesting,
      isPC,
      lang,
      trackingInfo,
      userCountry,
      getOnClickHandler
    ]
  );

  const crossSellProps = useCrossSellProps(crossActivityProps);

  return (
    crossSellProps && (
      <div className="headerCrossSale" data-testid="cross-sell-links-pc">
        {Object.keys(crossSellProps).map(key => {
          const childProps = crossSellProps[key];

          if (!childProps || childProps.isEnabled === false) return <></>;

          const trackingInfoLocal = trackingInfo
            ? Object.assign({}, trackingInfo, { dataLabel: childProps.name })
            : Object.assign({}, trackingInfo, {
                dataCategory: "default",
                dataAction: "click",
                dataLabel: childProps.name
              });

          const { svgId, svgText, asImage, ...restProps } = childProps;

          return (
            childProps && (
              <a
                {...restProps}
                key={key}
                data-category={trackingInfoLocal.dataCategory}
                data-action={trackingInfoLocal.dataAction}
                data-label={trackingInfoLocal.dataLabel}
                data-value=""
              >
                <SVGIcon2 iconName={svgId} asImage={asImage}>
                  {svgText && (
                    <text className="letterCrossIcons">{svgText}</text>
                  )}
                </SVGIcon2>
              </a>
            )
          );
        })}
      </div>
    )
  );
};

CrossActivity.propTypes = {
  trackingInfo: PropTypes.object
};

export default React.memo(CrossActivity);
